"use strict";
// Parity-test entry point. Force-feed an item sequence and response sequence;
// emit the theta / SE trajectory. No item selection, no stopping logic.
//
// Used to validate against Promin (Concerto + catR) and PROMIS reference
// scoring (HealthMeasures / mirtCAT): take the items + responses the
// reference engine administered, run them through here, diff theta and
// T-score. Sidesteps the impossible problem of matching R's RNG stream
// from JavaScript.
Object.defineProperty(exports, "__esModule", { value: true });
exports.replayScore = void 0;
const irtMethods_1 = require("./irtMethods");
const utilities_1 = require("./utilities");
/**
 * @typedef {import('./types').IRTConfig} IRTConfig
 */
/**
 * @typedef {import('./types').Response} Response
 */
/**
 * @typedef {'BM' | 'EAP'} EstimatorMethod
 */
/**
 * @typedef {Object} ReplayStep
 * @property {number} step       1-indexed item position in the administered sequence
 * @property {number} theta      Theta estimate after `step` items
 * @property {number} se         Standard error after `step` items
 */
/**
 * @typedef {Object} ReplayResult
 * @property {ReplayStep[]} trajectory  Per-item theta / SE evolution
 * @property {{ theta: number, se: number }} final  Estimates after the final item
 */
/**
 * @typedef {Object} ReplayInput
 * @property {IRTConfig} config
 * @property {Response[]} responses
 * @property {EstimatorMethod} [method]   Defaults to 'BM'
 */
/**
 * Replay a fixed item sequence and produce the theta / SE trajectory.
 * @param {ReplayInput} input
 * @returns {ReplayResult}
 */
function replayScore({ config, responses, method = 'BM' }) {
    const params = (0, utilities_1.getParamsFromConfig)(config);
    /** @type {ReplayStep[]} */
    const trajectory = [];
    for (let i = 1; i <= responses.length; i += 1) {
        const slice = responses.slice(0, i);
        const theta = (0, irtMethods_1.estimateTheta)(params, slice, { method });
        const se = (0, irtMethods_1.getStandardError)(params, slice, theta, { method });
        trajectory.push({ step: i, theta, se });
    }
    const final = trajectory.length > 0
        ? {
            theta: trajectory[trajectory.length - 1].theta,
            se: trajectory[trajectory.length - 1].se,
        }
        : { theta: 0, se: Infinity };
    return { trajectory, final };
}
exports.replayScore = replayScore;
//# sourceMappingURL=replay.js.map